// import React, { useEffect, useState } from "react";
// import "./ProfitLoss.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { toast } from "react-toastify";
// import axios from "axios";


// const API_URL = "https://payyug.in/api";
// const ProfitLoss = () => {
//   const [plData,setPlData]=useState([])

//     const { profile } = useSelector((state) => state.userProfile);
//   const dispatch = useDispatch();

//     useEffect(() => {
//       dispatch(fetchUserProfile());
//     }, [dispatch]);

//     const fetchPLData=async()=>{
//       if(!profile?.superAdminId) return;
//       try{
//         const res=await axios.get(`${API_URL}/report/profit-loss`,{
//           params:{
//             superAdminId:profile?.superAdminId
//           }
//         })
//         setPlData(res?.data)
//       }catch(err){
//         toast.error(err?.response?.data?.message||"Something went wrong")
//       }
//     }

//     useEffect(()=>{
//       fetchPLData()
//     },[profile?.superAdminId])


//   return (
//     <div className="profitLoss-container">
//       {/* Page Title */}
//       <h1 className="profitLoss-title">Profit - Loss</h1>

//       {/* Filter Section */}
//       <div className="profitLoss-filterBox">
//         <div className="profitLoss-filter-title">Filter By</div>
//         <div className="profitloss-filter-item-div">
//           <div className="profitloss-filter-item">
//             <label>Branch</label>
//             <select>
//               <option value="">Select Branch</option>
//               <option value="Bareilly">Bareilly</option>
//               <option value="Delhi">Delhi</option>
//               <option value="Mumbai">Mumbai</option>
//             </select>
//           </div>

//           <button className="profitloss-filter-btn">Filter</button>
//         </div>
//       </div>

//       {/* Layout: Income Left | Expense Right */}
//       <div className="profitLoss-report-container">
//         <h2 className="profitLoss-section-title">Profit Loss</h2>
//         <div className="profitLoss-report-section">
//         {/* Income Section */}
//         <div className="profitLoss-income-section">
//           <h2>Income</h2>
//           <p>Indirect Income: {plData?.income}</p>
//           <div className="profitLoss-income-box">
//             <table>
//               <tr>
//                 <td>1</td>
//                 <td>Interest(Income)</td>
//                 <td>
//                   <div className="income-td-div">
//                     <h2>Branch: Braily</h2>
//                     <div className="income-td-data">
//                       <p>Opening Balance: 0</p>
//                       <p>DR: 0</p>
//                       <p>CR: 0</p>
//                     </div>
//                   </div>
//                 </td>
//               </tr>
//               <tr>
//                 <td>2</td>
//                 <td>File Charge</td>
//                 <td>
//                   <div className="income-td-div">
//                     <h2>Branch: Braily</h2>
//                     <div className="income-td-data">
//                       <p>Opening Balance: 0</p>
//                       <p>DR: 0</p>
//                       <p>CR: 0</p>
//                     </div>
//                   </div>
//                 </td>
//               </tr>
//               <tr>
//                 <td>3</td>
//                 <td>Processing Fee</td>
//                 <td>
//                   <div className="income-td-div">
//                     <h2>Branch: Braily</h2>
//                     <div className="income-td-data">
//                       <p>Opening Balance: 0</p>
//                       <p>DR: 0</p>
//                       <p>CR: 0</p>
//                     </div>
//                   </div>
//                 </td>
//               </tr>
//               <tr>
//                 <td>4</td>
//                 <td>Loan Sattlement P & L</td>
//                 <td></td>
//               </tr>
//               <tr>
//                 <td>5</td>
//                 <td>Sattlement Charges</td>
//                 <td></td>
//               </tr>
//               <tr>
//                 <td>6</td>
//                 <td>Penalty Charges</td>
//                 <td></td>
//               </tr>
//               <tr>
//                 <td>7</td>
//                 <td>Unknown4</td>
//                 <td></td>
//               </tr>
//               <tr>
//                 <td>8</td>
//                 <td>Previous Collection</td>
//                 <td></td>
//               </tr>
//             </table>
//           </div>
//         </div>

//         {/* Expense Section */}
//         <div className="profitLoss-expense-section">
//           <h2>Expense</h2>
//           <p>Indirect Expense: {plData?.expense}</p>
//           <div className="profitLoss-expense-box">
//             <table>
//               <tr>
//                 <td>1</td>
//                 <td>Salary</td>
//                 <td>
//                   <ul>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                   </ul>
//                 </td>
//               </tr>
//               <tr>
//                 <td>2</td>
//                 <td>RD Interest Payout</td>
//                 <td>
//                   <ul>
//                     <li>Head Office JMC</li>
//                   </ul>
//                 </td>
//               </tr>
//               <tr>
//                 <td>3</td>
//                 <td>RD Payout</td>
//                 <td>
//                   <ul>
//                     <li>Head Office JMC</li>
//                   </ul>
//                 </td>
//               </tr>
//               <tr>
//                 <td>4</td>
//                 <td>Electricity Bill</td>
//                 <td>
//                   <ul>
//                     <li>Head Office JMC</li>
//                     <li>Head Office JMC</li>
//                   </ul>
//                 </td>
//               </tr>
//             </table>
//           </div>
//         </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default ProfitLoss;





import React, { useEffect, useState } from "react";
import "./ProfitLoss.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import axios from "axios";

const API_URL = "https://payyug.in/api";

const ProfitLoss = () => {
  const [plData, setPlData] = useState({});

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchPLData = async () => {
    if (!profile?.superAdminId) return;

    try {
      const res = await axios.get(`${API_URL}/report/profit-loss`, {
        params: {
          superAdminId: profile.superAdminId,
        },
      });

      setPlData(res.data);
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Something went wrong"
      );
    }
  };

  useEffect(() => {
    fetchPLData();
  }, [profile?.superAdminId]);

  const income = Number(plData?.income || 0);
  const expense = Number(plData?.expense || 0);
  const profit = income - expense;

  return (
    <div className="pl-container">
      <div className="pl-header">
        <h1>Profit & Loss Report</h1>
        <p>Indirect Income vs Indirect Expense</p>
      </div>

      <div className="pl-cards">
        <div className="pl-card income">
          <h3>Indirect Income</h3>
          <h2>₹ {income.toLocaleString("en-IN")}</h2>
        </div>

        <div className="pl-card expense">
          <h3>Indirect Expense</h3>
          <h2>₹ {expense.toLocaleString("en-IN")}</h2>
        </div>

        <div className={`pl-card ${profit >= 0 ? "profit" : "loss"}`}>
          <h3>{profit >= 0 ? "Net Profit" : "Net Loss"}</h3>
          <h2>
            ₹ {Math.abs(profit).toLocaleString("en-IN")}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default ProfitLoss;